import { render, staticRenderFns } from "./BatchKpis.vue?vue&type=template&id=50a9eeb6"
import script from "./BatchKpis.vue?vue&type=script&lang=js"
export * from "./BatchKpis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports